import { CommitClass } from '../contract/constants.js';
import { immutable } from '../contract/stable.js';

export function createAssociativeTrace(input) {
  if (!Number.isInteger(input.version) || input.version < 1) throw new Error('TRACE_INVALID: version must be a positive integer');
  return immutable({
    traceId: input.traceId, version: input.version, eventIds: immutable([...input.eventIds]), representation: input.representation,
    commitClass: CommitClass.ASSOCIATIVE, provenanceLedger: immutable([...input.provenanceLedger]),
    evidenceLedger: immutable([...input.evidenceLedger]), lineageIds: immutable([...new Set(input.lineageIds)]),
    attentionWeight: input.attentionWeight, recallCount: input.recallCount,
    createdAt: input.createdAt, lastUpdatedAt: input.lastUpdatedAt
  });
}
